var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row d-flex align-items-center pt-1" }, [
    _vm.preorderMention
      ? _c("p", {
          staticClass: "col-12 mb-sm-0",
          domProps: { innerHTML: _vm._s(_vm.preorderMention) },
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-12 col-sm-auto text-center",
        staticStyle: { "flex-grow": "1" },
      },
      [
        _c("span", { staticClass: "visually-hidden" }, [
          _vm._v("Continuer et poursuivre votre commande"),
        ]),
        _vm._v(" "),
        _c("Bouton", {
          ref: "ctaButton",
          staticClass: "d-block mx-auto w-100",
          attrs: {
            "is-button": !!_vm.dataTarget,
            "data-bs-toggle": _vm.dataTarget ? "modal" : null,
            "data-bs-target": _vm.dataTarget,
            "is-primary": true,
            label: _vm.label,
            "is-disabled": _vm.isDisabled,
            "data-oevent-category": _vm.dataTarget
              ? "popin_poursuivre_votre_commande"
              : "fiche_produit",
            "data-oevent-action": _vm.label,
            "data-oevent-label": _vm.href,
            href: _vm.href,
          },
          on: { click: _vm.handleCtaClick },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-12 col-sm-auto py-1",
        staticStyle: { "flex-grow": "100" },
      },
      [
        _c("availability-mention", {
          attrs: {
            available: _vm.availableOnline,
            label: _vm.availableOnline
              ? _vm.onlineLabel
              : "Indisponible en ligne",
          },
        }),
        _vm._v(" "),
        _c("availability-mention", {
          attrs: {
            available: _vm.availableEresa,
            label: _vm.availableEresa
              ? "Disponible en Click & Collect"
              : "Indisponible en Click & Collect",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }